var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1e1e1e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m502.26 896.26h33c21.25 0 42 5.75 59.75 16.5l380.25 233.5c4 2.5 8.5 3.75 13 3.75 4.25 0 8.5-1 12.25-3.25 8-4.25 12.75-12.75 12.75-21.75v-947.25c0-9.25-4.75-17.5-12.75-22-7.75-4.25-17.5-4-25.25 0.5l-92.5 57c-3.25 2-6.25 5-8.25 8.25l-393.5 636.5c-4.75 7.75-5 17.5-0.75 25.25 4.5 8 13 13 22 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.51 1146.3c4.25 2.5 8.75 3.75 13.25 3.75 8.25 0 16.5-4.25 21.25-12l156-252.5 0.5-0.75 312.5-505.75 179.75-290.75c7.25-11.75 3.75-27.25-8-34.5s-27.25-3.75-34.5 8l-177.5 287.25-66.5 40.75c-18 11-38.75 16.75-60 16.75h-183.5c-42 0-76 34.25-76 76v337.5c0 33.25 21.25 61.5 50.75 71.75l-136 220c-7.25 11.75-3.75 27.25 8 34.5z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.0d6d0d3933695a00f8abc77536738518.svg";
export { ForwardRef as ReactComponent };